export const AuthTypes = {
    GET_USER: "GET_USER",
    UPDATE_USER_PROFILE: "UPDATE_USER_PROFILE",
    NOTIFICATION_SWITCH: "NOTIFICATION_SWITCH",
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT"
}
